// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3GaX7","calendarButtons":"ClockData_calendarButtons__bsBK1"};